import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import classNames from 'classnames/bind'

const styles = theme => ({
  tabRoot: {
    minHeight: '40px',
    minWidth: 'auto',
    opacity: 1,
    '& span': {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    '&.active': {
      backgroundColor: theme.palette.primary.main,
      color: theme.colors.white,
    },
    '&.inactive': {
      backgroundColor: `var(--gameday-body-textColor, ${theme.body.textColor})`,
      fontWeight: '400',
    },
  },
})

function SecondaryTab(props) {
  const { value, label, onClick, classes, active } = props
  return (
    <Tab
      value={value}
      label={label}
      onClick={onClick}
      className={classNames(classes.tabRoot, active ? 'active' : 'inactive')}
      tabIndex="-1"
      aria-label={label}
    />
  )
}

export default withStyles(styles)(SecondaryTab)
